"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Seahouse;
exports.length = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var length = 87.5;
exports.length = length;

function Seahouse(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 51 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 52 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#fff" : _ref$color,
      shapeRef = _ref.shapeRef,
      style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 51.5 52.5",
    width: width,
    height: height,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("path", {
    ref: shapeRef,
    stroke: color,
    fill: "none",
    d: "M50.5,52.5c1.7-16.3-6.1-32.1-27-28.5c-11,1.9-16.7-0.7-20.7-7.8C0,11.2,1.1,0.5,1.1,0.5",
    strokeLinecap: "round"
  }));
}